// This is a refactored version of the Time.js screen using custom styled button tabs
// with a visual style inspired by the NotificationBell component tabs

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import RestaurantCalendarOpenClosedDays from "../components/restaurant_schedule/RestaurantCalendarOpenClosedDays";
import EstimatedTimePage from "../components/EstimatedTimeCustomersSpend";
import DropDownButton from "../components/DropDownButton";
import RestaurantNotifications from "../components/notifications/RestaurantNotifications";
import InputDayOrHour from "../components/InputDayOrHour";
import {
  fetchRestaurantDetails,
  fetchRestaurantOpenDays,
  updateRestaurant,
  fetchHoursEach,
  fetchPlaceOfTable,
} from "../actions/restaurantActions";
import {
  Container,
  CardHeader,
  CardHeaderTitle,
  ModernButton,
  GridContainer,
  SettingsCard,
  SectionTitle,
  Text,
  TabsContainer,
} from "../components/DefaultImports";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCalendar,
  faStopwatch,
  faGear,
  faUtensils,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

function Notifications() {
  const dispatch = useDispatch();
  const params = useParams();
  const [restaurant_id, setRestaurant_id] = useState(false);

  const [eachTime, setEachTime] = useState("00:15");
  const [name, setName] = useState("");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [errorMessage, setErrorMessage] = useState("ok_status");
  const [showError, setShowError] = useState(false);
  const [activeTab, setActiveTab] = useState("restaurant_notifications");
  const [reconfirmation_duration, setReconfirmation_duration] = useState("");
  const [messageReminderTime, setMessageReminderTime] = useState("");
  const [timeToCancelledWarning, setTimeToCancelledWarning] = useState("");
  const [reconfirmation_time_before_date, setReconfirmation_time_before_date] =
    useState("");
  const generateIntervalOptions = () => {
    const intervalOptions = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        // Format the hour and minute values to have two digits
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;

        if (time >= "00:15" && time <= "08:00") {
          intervalOptions.push(time);
        }
      }
    }
    return intervalOptions;
  };

  const generateNumberOptions = () => {
    const numberOptions = [];
    for (let i = 0; i < 100; i++) {
      numberOptions.push(i);
    }
    return numberOptions;
  };

  // Usage:
  const [numberOptions, setNumberOptions] = useState(generateNumberOptions());
  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions()
  );

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
      dispatch(fetchPlaceOfTable(restaurants.id));
    }
  }, [restaurants]);

  useEffect(() => {
    //dispatch(fetchRestaurantDetails(restaurant_id));
    dispatch(fetchRestaurantOpenDays(restaurant_id));
    dispatch(fetchHoursEach(restaurant_id));
  }, [dispatch, restaurant_id]);

  useEffect(() => {
    if (restaurants) {
      if (restaurants.each_time) setEachTime(restaurants.each_time);
      if (restaurants.accept_people_per_each_time !== undefined)
        setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      if (restaurants.limit_people_reservation !== undefined)
        setLimitPeopleReservation(restaurants.limit_people_reservation);
      setReconfirmation_duration(restaurants.reconfirmation_duration);
      setReconfirmation_time_before_date(
        restaurants.reconfirmation_time_before_date
      );
      setMessageReminderTime(restaurants.send_message_reminder_to_customers);
      setTimeToCancelledWarning(restaurants.time_to_cancelled_warning);
    }
  }, [restaurants]);

  const handleIntervalTimeChange = (option) => setEachTime(option);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "accept_people_per_each_time") {
      setAcceptPeoplePerEachTime(value);
    } else if (name === "limit_people_reservation") {
      setLimitPeopleReservation(value);
    }
  };

  const handleReconfirmation = (value) => {
    setReconfirmation_duration(value);
  };
  const handleMessageReminderTime = (value) => {
    setMessageReminderTime(value);
  };

  const handleReconfirmation_time_before_date = (value) => {
    setReconfirmation_time_before_date(value);
  };

  function checkEmptyStates() {
    let emptyStates = [];
    if (!eachTime) emptyStates.push("Cada tempo");
    if (!acceptPeoplePerEachTime || acceptPeoplePerEachTime <= 0)
      emptyStates.push("Capacidade por horário");
    if (!limitPeopleReservation || limitPeopleReservation <= 0)
      emptyStates.push("Limite por grupo");
    return emptyStates.length > 0
      ? `Preencher: ${emptyStates.join(", ")}`
      : "ok_status";
  }

  function checkForErrorsAndUpdateRestaurant() {
    const status_error = checkEmptyStates();
    setErrorMessage(status_error);
    if (status_error === "ok_status") {
      console.log("timeToCancelledWarning: ", timeToCancelledWarning);
      setShowError(false);
      dispatch(
        updateRestaurant(restaurant_id, {
          /* 
          each_time: eachTime,
          accept_people_per_each_time: acceptPeoplePerEachTime,
          limit_people_reservation: limitPeopleReservation, */
          time_to_cancelled_warning: timeToCancelledWarning,
          send_message_reminder_to_customers: messageReminderTime,
          reconfirmation_time_before_date: reconfirmation_time_before_date,
          reconfirmation_duration: reconfirmation_duration,
        })
      );
      toast.success("Guardado com sucesso", {
        style: { color: "#EE754C" },
        icon: (
          <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#EE754C" }} />
        ),
        progressStyle: { backgroundColor: "#EE754C" },
        autoClose: 1000,
      });
    } else {
      setShowError(true);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndUpdateRestaurant();
  };

  const handleTimeCancelWarning = (value) => {
    setTimeToCancelledWarning(value);
  };

  return (
    <Container>
      <ToastContainer />
      <CardHeader>
        <CardHeaderTitle>Notificações</CardHeaderTitle>
      </CardHeader>
      <TabsContainer>
        <StyledTabButton
          active={activeTab === "restaurant_notifications"}
          onClick={() => setActiveTab("restaurant_notifications")}
        >
          <FontAwesomeIcon icon={faUtensils} /> Restaurante
        </StyledTabButton>
        <StyledTabButton
          active={activeTab === "client_notifications"}
          onClick={() => setActiveTab("client_notifications")}
        >
          <FontAwesomeIcon icon={faUsers} /> Clientes
        </StyledTabButton>
      </TabsContainer>

      {activeTab === "restaurant_notifications" && (
        <RestaurantNotifications restaurant_id={restaurant_id} />
      )}

      {activeTab === "client_notifications" && (
        <Form onSubmit={handleSubmit}>
          <GridContainer style={{ marginTop: "10px" }}>
            <SettingsCard>
              <SectionTitle>Reconfirmações</SectionTitle>

              <Text>
                <FieldRow>
                  <span>
                    Enviar pedido de reconfirmação se a reserva for marcada com
                    mais de:
                  </span>

                  <InputDayOrHour
                    initialValue={restaurants.reconfirmation_duration}
                    setValue={handleReconfirmation}
                  />
                  <span>dias de antecedência.</span>
                </FieldRow>
              </Text>

              <Text>
                <FieldRow>
                  <span>Enviar pedido de reconfirmação ao cliente:</span>
                  <InputDayOrHour
                    initialValue={restaurants.reconfirmation_time_before_date}
                    setValue={handleReconfirmation_time_before_date}
                  />
                  <span>antes da reserva.</span>
                </FieldRow>
              </Text>
            </SettingsCard>

            <SettingsCard>
              <SectionTitle>Lembretes</SectionTitle>

              <Text>
                <FieldRow>
                  <span>Enviar lembrete da reserva ao cliente</span>
                  <InputDayOrHour
                    initialValue={
                      restaurants.send_message_reminder_to_customers
                    }
                    setValue={handleMessageReminderTime}
                  />
                  <span>antes da hora da reserva.</span>
                </FieldRow>
              </Text>
            </SettingsCard>

            <SettingsCard>
              <SectionTitle>Notificações</SectionTitle>

              <Text>
                <FieldRow>
                  <span>
                    Receber notificação se o cliente cancelar com menos de
                  </span>
                  <InputDayOrHour
                    initialValue={restaurants.time_to_cancelled_warning}
                    setValue={handleTimeCancelWarning}
                  />
                  <span>de antecedência.</span>
                </FieldRow>
              </Text>
            </SettingsCard>
          </GridContainer>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ModernButton type="submit" color="#EE754C" fontSize="14px">
              Guardar
            </ModernButton>
          </div>
        </Form>
      )}
    </Container>
  );
}

export default Notifications;

const Form = styled.form`
  width: 100%;
`;

const StyledTabButton = styled.button`
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 7px;
  background-color: ${(props) => (props.active ? "#ee754c" : "#f2f2f2")};
  color: ${(props) => (props.active ? "white" : "#333")};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => (props.active ? "#d96945" : "#e6e6e6")};
  }

  @media (max-width: 768px) {
    font-size: 14px;
    flex: 1 1 auto;
    justify-content: center;
  }
`;
const FieldRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #6c757d;
`;
